import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import AppLayout from "../../../layout/AppLayout";
import { FaMobileAlt, FaEnvelope } from "react-icons/fa";
import Phone_Number_Login from "./Phone_Number_Login/Phone_Number_Login";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Email_Login from "./Email_Login/Email_Login";
import Login_Header from "../../Common/Common_Component/Login_Header/Login_Header";
import Verification_Puzzle_modal from "../../Common/Common_Component/Common_Modal/Verification_Puzzle_modal/Verification_Puzzle_modal";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { AuthLogin } from "../../../features/auth/Slice";
import Cookies from "js-cookie";
import { Context } from "../../../utils/context";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("phone");
  const [puzzleShow, setPuzzleShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Suceesfull");
  const { signin } = useContext(Context)
  const {
    control,
    register,
    resetField, reset,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      contact_no: "",
      email: "",
      password: "",
    },
  });

  const [contact_no, email, password] = watch(["contact_no", "email", "password"]);
  const showCss = (activeTab === "phone" ? contact_no : email) && password;

  useEffect(() => {
    const saved = Cookies.get("moneyking_remember");
    if (saved) {
      const parsed = JSON.parse(saved);
      reset(parsed); // react-hook-form reset pre-fills the fields
    }
  }, []);
  useEffect(() => {
    if (activeTab === "phone") {
      resetField("email");
    } else {
      resetField("contact_no");
    }
  }, [activeTab]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("type", activeTab);
      formData.append("password", data?.password);
      formData.append("rememberMe", data?.rememberMe);
      console.log({ rememberMe: data });

      if (activeTab === "phone") {
        formData.append("contact_no", data?.contact_no);
      } else {
        formData.append("email", data?.email);
      }

      const res = await dispatch(AuthLogin(formData));
      if (res.meta?.requestStatus === "fulfilled") {

        if (data?.rememberMe) {
          Cookies.set(
            "moneyking_remember",
            JSON.stringify({
              contact_no: data?.contact_no,
              email: data?.email,
              password: data?.password,
              rememberMe: data?.rememberMe
            }),
            {
              expires: 7,
              secure: true,
              sameSite: "strict",
            }
          );
        } else {
          Cookies.remove("moneyking_remember");
        }
        // setModalMessage("Login Sucessfully");
        // setModalShow(true);
        setPuzzleShow(true);
      } else if (res.meta?.requestStatus === "rejected") {
        console.error("Login rejected:", res.error);
        setModalMessage(res?.payload.errors);
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <>
      <div className="login-page">
        {/* Header */}
        <Login_Header
          title="Log in"
          subTitle="Please Log in with your phone number or email if you forget your password, Please contact customer service"
        />

        {/* Body */}
        <div className="login-body">
          {/* Tabs */}
          <div className="login-tabs">
            <div
              className={`tab ${activeTab === "phone" ? "active" : ""}`}
              onClick={() => setActiveTab("phone")}
            >
              <div>
                <FaMobileAlt />
              </div>
              Phone Number
            </div>

            <div
              className={`tab ${activeTab === "email" ? "active" : ""}`}
              onClick={() => setActiveTab("email")}
            >
              <div>
                <FaEnvelope />
              </div>
              Email Login
            </div>
          </div>

          {/* Form wraps fields + submit button */}
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>
            {/* Phone Field */}
            {activeTab === "phone" && (
              <Phone_Number_Login
                control={control}
                register={register}
                errors={errors}
              />
            )}

            {/* Email Field */}
            {activeTab === "email" && (
              <Email_Login
                register={register}
                errors={errors}
              />
            )}

            {/* Remember */}
            <div className="remember mb-3">
              <Form.Check
                type="checkbox"
                label="Remember Password"
                className="checkbox_input"
                {...register("rememberMe")}
              />
            </div>

            {/* Buttons */}
            <Button
              type="submit"
              className={showCss ? "btn_register_bg mb-3" : "btn-login mb-3 "}
              disabled={!showCss || isSubmitting}
            >
              {isSubmitting ? "Logging in..." : "Log in"}
            </Button>
          </Form>

          <Button
            className="btn-register  mb-3"
            onClick={() => navigate("/sign-up")}
          >
            Register
          </Button>

          {/* Bottom Links */}
          <div className="bottom_links">
            <div
              className="link_text"
              onClick={() => navigate("/forgot-password", { state: { activeTab } })}            >
              <img
                src="/assets/images/icons/lock.png"
                alt="icon"
                className="contact_icons"
              />
              <p>Forget Password</p>
            </div>
            {/* <div
              className="link_text"
              onClick={() => navigate("/self-service-center")}
            >
              <img
                src="/assets/images/icons/chat.png"
                alt="icon"
                className="contact_icons"
              />
              <p>Customer Service</p>
            </div> */}
          </div>
        </div>
      </div>

      <Verification_Puzzle_modal
        show={puzzleShow}
        onHide={() => setPuzzleShow(false)}
        onVerified={() => {
          if (signin) {
            navigate("/home");
          } else {
            setPuzzleShow(false);
          }
        }}
      />

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
};

export default Login;